import axios from "axios";
import { BaseApiUrl } from './base';
import { LONG_REQUEST_TIMEOUT } from './http';

const base = BaseApiUrl;

// 教师管理 (如果 api.js 确实没有，这里补一个)
export const getTeacherMasterListPage = (params) => {
    return axios.get(`${base}/api/TeacherMaster/get`, { params: params });
};

// 人脸识别模块 (Aliyun FaceBody)
export const createFaceDb = (params) => {
    return axios.post(`${base}/api/FaceBody/CreateFaceDb`, params).then((res) => res.data);
};
export const addFaceEntity = (params) => {
    return axios.post(`${base}/api/FaceBody/AddFaceEntity`, params).then((res) => res.data);
};
export const batchAddFaceEntity = (params) => {
    return axios.post(`${base}/api/FaceBody/BatchAddFaceEntity`, params).then((res) => res.data);
};
export const addFace = (params) => {
    return axios.post(`${base}/api/FaceBody/AddFace`, params).then((res) => res.data);
};
export const batchAddFace = (params) => {
    return axios.post(`${base}/api/FaceBody/BatchAddFace`, params).then((res) => res.data);
};
/** 当前部门是否存在进行中的人脸批量同步（Status=0） */
export const getFaceBatchSyncJobRunning = (params) => {
    return axios.post(`${base}/api/FaceBody/GetFaceBatchSyncJobRunning`, params).then((res) => res.data);
};
/** 同步主表分页 */
export const getFaceBatchSyncJobPage = (params) => {
    return axios.post(`${base}/api/FaceBody/GetFaceBatchSyncJobPage`, params).then((res) => res.data);
};
/** 同步明细分页 */
export const getFaceBatchSyncJobItemPage = (params) => {
    return axios.post(`${base}/api/FaceBody/GetFaceBatchSyncJobItemPage`, params).then((res) => res.data);
};
export const searchFace = (params) => {
    return axios.post(`${base}/api/FaceBody/SearchFace`, params).then((res) => res.data);
};
/** 人脸搜索（上传/拍照文件）。创建于 2026-09-15 */
export const searchFaceByFile = (formData) => {
    return axios.post(`${base}/api/FaceBody/SearchFaceByFile`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => res.data);
};
// 根据部门ID或学校ID获取人脸库 (支持递归查找顶级学校)
export const getFaceDbBySchool = (params) => {
    return axios.get(`${base}/api/FaceBody/GetFaceDbBySchool`, { params: params });
};
export const getPersonFaceStatus = (params) => {
    return axios.get(`${base}/api/FaceBody/GetPersonFaceStatus`, { params: params }).then((res) => res.data);
};
export const getPersonFaceStatusList = (params) => {
    return axios.post(`${base}/api/FaceBody/GetPersonFaceStatusList`, params).then((res) => res.data);
};
export const deleteFaceEntity = (params) => {
    return axios.post(`${base}/api/FaceBody/DeleteFaceEntity`, params).then((res) => res.data);
};

/** 人脸质量检测（按人员头像或图片地址）。创建于 2026-09-15 */
export const detectFace = (params) => {
    return axios.post(`${base}/api/FaceBody/DetectFace`, params).then((res) => res.data);
};

/** 人脸质量检测（上传文件）。创建于 2026-09-15 */
export const detectFaceByFile = (formData) => {
    return axios.post(`${base}/api/FaceBody/DetectFaceByFile`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => res.data);
};

/** 当前部门批量人脸质量检测（长耗时）。创建于 2026-09-15 */
export const batchDetectFace = (params) => {
    return axios.post(`${base}/api/FaceBody/BatchDetectFace`, params, {
        timeout: LONG_REQUEST_TIMEOUT,
    }).then((res) => res.data);
};
